import { MapPin, Globe } from "lucide-react";

const TrustBar = () => {
  return (
    <section className="py-6 bg-card">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-3 md:gap-6 flex-wrap">
          <div className="flex items-center gap-1.5">
            <MapPin className="w-4 h-4 text-primary" />
            <span className="font-display text-sm font-medium text-foreground/80">Based in South Wales</span>
          </div>
          <span className="text-border">·</span>
          <div className="flex items-center gap-1.5">
            <Globe className="w-4 h-4 text-primary" />
            <span className="font-display text-sm font-medium text-foreground/80">Working with families worldwide</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
